import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import {CancelSubscriptionModalComponent} from './cancel-subscription-modal';

export const CancelSubscriptionModalModule: string = ng
  .module('cancel-subscription-modal', [
    'ui.bootstrap',
    uiRouter
  ])
  .component('cancelSubscriptionModal', CancelSubscriptionModalComponent)
  .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/commons/components/cancel-subscription-modal/cancel-subscription-modal.module.ts